class enabledEducatorsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/enabled-educator/:route',{},{
			getEnabledEducators:{
				method:'GET',
				params : {}
			},
			saveEnabledEducators:{
				method:'POST',
				params : {}
			},
		});

		const servicesPeriod = $resource(SERVICE_URL_CONSTANT.adminPanel +'/period/:route',{},{
			getPeriod:{
				method:'GET',
				params : {}
			},
		});

		return {
			services : services,
			servicesPeriod: servicesPeriod
		};
	}
}

enabledEducatorsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.enabledEducatorsServices', [])
.service('enabledEducatorsServices', enabledEducatorsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledEducators/enabledEducatorsServices.js